/**
 * @description 接受消息外壳组件
 */

import {h} from 'preact';
import './receive-wrap.scss';

export default ({children, session, ...props})=>{
  let src = 'https://si.geilicdn.com/vshop952769023-wholesale-apply-1488194077393.jpg?w=150&h=150&cp=1';

  return(
    <div class='msg__rwrap'>
      <img src={session.portrait} alt="portrait" class='msg__rwrap--portrait'/>

      <div class='msg__rwrap--content'>
        <span class='msg__left--icon'/>
        {children}
      </div>
    </div>
  )
}


/** WEBPACK FOOTER **
 ** ./components/message/receive-wrap/receive-wrap.jsx
 **/